export const PHSelfEmpSmallBusIntentOptions = {
  file_taxes: { label: 'File taxes', value: 'File taxes' },
  handle_bookkeeping_or_payroll: {
    label: 'Handle bookkeeping or payroll',
    value: 'Handle bookkeeping or payroll'
  },
  help_with_tax_issues: {
    label: 'Help with tax issues',
    value: 'Help with tax issues'
  },
  answer_general_questions: {
    label: 'Answer general questions',
    value: 'Answer general questions'
  },
  something_else: { label: 'Something else', value: 'Something else' }
} as const;
